import parse from 'csv-parse'
import units from '@/sui/data/units'
import modules from '@/sui/data/modules'
import convert from '@/sui/data/sheets/convert'

function loadStep (title, error) {
  return {
    title: title,
    run: function (vm, data, iteration) {
      const fileInput = vm.$refs.fileInput

      if (iteration === 0) {
        this.reading = false
        fileInput.value = ''
      }

      return {
        end: fileInput.value !== '',
        success: true
      }
    },

    setError: function (e) {
      return `error: ${e}`
    }
  }
}

function transformStep (title, error, msg, transform) {
  return {
    reading: false,
    readError: null,
    output: null,
    index: 0,
    progress: {
      value: 0
    },

    title: title,
    run: function (vm, data, iteration) {
      if (iteration === 0) {
        this.reading = true

        const reader = new FileReader()
        reader.onload = this.parse.bind(this)
        const fileInput = vm.$refs.fileInput
        reader.readAsText(fileInput.files[0])
      } else if (!this.reading) {
        if (this.readError != null) {
          return {
            end: true,
            error: this.readError
          }
        }

        try {
          const o = this.output
          const max = o.length
          const step = 100
          const end = this.index + step >= max ? max : this.index + step
          this.progress.value = Math.round(100 * end / max)

          transform(vm, data, o, this.index, end)
          this.index = end
        } catch (e) {
          return {
            end: true,
            success: false,
            error: `Fichier invalide: ${e}.`
          }
        }

        if (this.index === this.output.length) {
          return {
            end: true,
            success: true,
            msg: msg(this.output.length)
          }
        }
      }

      return { end: false }
    },

    parse: function (e) {
      const instance = this
      parse(
        e.target.result,
        {
          comment: '#',
          columns: true,
          cast: true,
          delimiter: ';',
          skip_empty_lines: true
        },
        function (err, output) {
          instance.reading = false
          instance.readError = err
          instance.output = output
          instance.index = 0
        }
      )
    },

    setError: function (e) {
      return `${error} : ${e}`
    }
  }
}

function purgeStep (t, sc) {
  return {
    title: 'Purge des fiches',
    index: 0,
    run: function (vm, data, iteration) {
      if (iteration === 0) {
        this.index = 0
        this.ended = 0
        this.launched = 0
        this.errors = []
        this.sheets = Object.keys(data.sheets)
        this.purged = []
      }
      const max = this.sheets.length
      for (let i = 0; i < max; i++) {
        const stc = data.serverSheets[i]
        if (stc.errors.length > 0) {
          this.errors.push(stc.errors)
          continue
        }

        if (t !== 'bactADI' && t !== 'observa4') {
          const uy = units[vm.surveillance.year]
          const ut = uy.find(stc.sheet.unitType)
          const u = vm.surveillance.getUf(t, ut.index, stc.sheet.uf)
          if (u == null) {
            this.errors.push(
              `Fiche ${stc.sheet.sheetNumber}: Le service ${stc.sheet.uf} (${stc.sheet.unitType}) n'est pas inscrit à cette modalité.`
            )
            continue
          }
        }

        var sheet = stc.sheet
        const module = modules[vm.surveillance.year][t]
        const steps = module.sheets.edit
        const stack = [{ steps: steps.fields, target: sheet }]
        while (stack.length > 0) {
          const it = stack[0]
          for (let i in it.steps) {
            const step = it.steps[i]
            if (step.initialize != null) {
              step.initialize(vm)
            }
            const ignore = step.ignore != null && step.ignore(it.target, sheet)
            if (ignore) {
              it.target[step.field] = (step.type === 'array') ? [] : null
              continue
            }

            if (step.type === 'array') {
              let target = it.target[step.field]
              if (target != null) {
                target.push({})
              } else {
                target = [{}]
                it.target[step.field] = target
              }
              for (let i = 0; i !== target.length; ++i) {
                const subitem = target[i]
                stack.push({
                  steps: step.config.fields,
                  target: subitem
                })
              }
            }
          }
          stack.shift()
        }
        this.launched++
        const c = convert.clientToServer(sheet)

        if (c.errors.length > 0) {
          this.errors.push(c.errors)
        } else {
          this.purged.push(c.sheet.f)
        }
      }

      data.sheets = this.purged
      return {
        end: true,
        success: this.errors.length === 0,
        error: this.errors.join('<br>')
      }
    },

    setError: function (e) {
      return `Impossible de purger les fiches : ${e}.`
    }
  }
}

function insertStep (t, sc) {
  return {
    title: 'Ajout des fiches en masse',
    index: 0,
    run: function (vm, data, iteration) {
      if (iteration === 0) {
        this.index = 0
        this.ended = 0
        this.launched = 0
        this.errors = []
        this.sheets = Object.keys(data.sheets)
      }
      const request = {
        t: t,
        s: vm.surveillance.id,
        u: vm.surveillance.registrator.id,
        sc: sc,
        f: []
      }

      const max = this.sheets.length
      if (this.index === max) {
        const end = this.launched === this.ended
        return {
          end: end,
          success: this.errors.length === 0,
          error: this.errors.join('<br>')
        }
      }

      const step = 100
      const end = this.index + step >= max ? max : this.index + step
      for (let i = this.index; i !== end; ++i) {
        request.f.push(data.sheets[this.sheets[i]])
      }
      this.index = end

      const instance = this
      instance.launched++
      vm.$store.dispatch('bosheet/insert', request).then(
        (response) => {
          if (response.data.err != null) {
            instance.errors.push(response.data.err)
          }
          instance.ended++
          return response
        }
      ).catch(
        (err) => {
          instance.ended++
          instance.errors.push(err)
        }
      )
      return { end: false }
    },

    setError: function (e) {
      return `Impossible d'ajouter les fiches : ${e}.`
    }
  }
}

export default {
  load: loadStep,
  transform: transformStep,
  purge: purgeStep,
  insert: insertStep
}
